// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import UserConstants from 'constants/UserConstants'
import { isEmail } from 'validator'

const UserActions = Marty.createActionCreators({
  id: 'UserActions',

  createUserWithEmail(email, password = null) {
    return this.app.queries.UserQueries.createUserWithEmail(email, password)
  },

  sendWelcomeEmail(isMobile) {
    return this.app.queries.UserQueries.sendWelcomeEmail(isMobile)
  },

  checkIfUserExistForEmailAndOrgHandle(email, orgHandle) {
    if (isEmail(email)) {
      return this.dispatch(UserConstants.CHECK_USER_EXISTENCE_BY_ORG_HANDLE_AND_EMAIL, email, orgHandle)
    }
  },

  updateUser(userId, params) {
    return this.dispatch(UserConstants.USER_UPDATE, userId, params)
  },

  changePasswordForUser(userId, password) {
    return this.dispatch(UserConstants.CHANGE_PASSWORD, userId, password)
  },

  userUpdated(userId, user) {
    return this.dispatch(UserConstants.USER_UPDATE_DONE, userId, user)
  },

  uploadUserAvatar(userId, file) {
    return this.dispatch(UserConstants.USER_AVATAR_UPLOAD, userId, file)
  },

  logoutUser() {
    return this.app.queries.UserQueries.logoutUser()
  },

  archiveUser(userId) {
    return this.dispatch(UserConstants.USER_ARCHIVE, userId)
  },

  archiveUsers(payload) {
    return this.dispatch(UserConstants.ARCHIVE_USERS, payload)
  }
})

export default UserActions



// WEBPACK FOOTER //
// ./src/scripts/actions/UserActions.js